import { createFocusTrap } from 'focus-trap';
import { add, listen, qs, qsa, remove, toggle } from '@fluorescent/dom';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { on } from '@/glow/events';
import accordions from '@/lib/accordions';

const classes = {
  visible: 'is-visible',
  active: 'active',
  fixed: 'is-fixed',
};

const selectors = {
  closeBtn: '[data-modal-close]',
  wash: '.modal__wash',
  modalContent: '.modal__content',
  accordion: '.accordion',
};

const modal = node => {
  const focusTrap = createFocusTrap(node, { allowOutsideClick: true });
  const wash = qs(selectors.wash, node.parentNode);
  const modalContent = qs(selectors.modalContent, node);
  let accordion = null;

  const events = [
    listen([qs(selectors.closeBtn, node), wash], 'click', e => {
      e.preventDefault();
      _close();
    }),
    listen(node, 'keydown', ({ keyCode }) => {
      if (keyCode === 27) _close();
    }),
    on('modal:open', (state, { modalContent, narrow = false }) => {
      toggle(node, 'modal--narrow', narrow);
      _renderModalContent(modalContent);
      _open();
    }),
  ];

  const _renderModalContent = content => {
    const clonedContent = content.cloneNode(true);
    modalContent.innerHTML = '';
    modalContent.appendChild(clonedContent);

    _initAccordion();
  };

  const _initAccordion = () => {
    accordion = accordions(qsa('.accordion', node));
  };

  const _open = () => {
    // Due to this component being shared between templates we have to
    // animate around it being fixed to the window
    add(node, classes.fixed);

    setTimeout(() => {
      add(node, classes.visible);
      add(node, classes.active);
    }, 50);

    focusTrap.activate();
    disableBodyScroll(node, {
      allowTouchMove: el => {
        while (el && el !== document.body) {
          if (el.getAttribute('data-scroll-lock-ignore') !== null) {
            return true;
          }
          el = el.parentNode;
        }
      },
      reserveScrollBarGap: true,
    });
  };

  const _close = () => {
    focusTrap.deactivate();
    remove(node, classes.visible);
    remove(node, classes.active);
    enableBodyScroll(node);

    setTimeout(() => {
      remove(node, classes.fixed);
      modalContent.innerHTML = '';
    }, 300);
  };

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
    accordion.unload();
  };

  return { unload };
};

export default modal;
